import type {CanvasChatMessage} from './canvas-types';

const syntheticRunId = (message:CanvasChatMessage):number|undefined => {
 const match=/^run-card-(\d+)$/.exec(message.id);
 if(message.role!=='assistant'||!match)return;
 const id=Number(match[1]);
 return Number.isSafeInteger(id)&&id>0&&(!message.playbookProgress?.workflowRunId||message.playbookProgress.workflowRunId===id)?id:undefined;
};
/** Replace a workflow-only recovery card with its actual assistant owner once
 * durable job or live progress identity arrives. Never dedupe by shared URLs,
 * labels, or proximity: distinct user requests must keep their own messages. */
export function reconcileRecoveredRunCards(messages:CanvasChatMessage[]):CanvasChatMessage[]{
 let next=messages;
 for(const fallback of messages){
  const runId=syntheticRunId(fallback);
  if(runId===undefined)continue;
  const real=next.filter(message=>message.role==='assistant'&&syntheticRunId(message)===undefined);
  const jobOwners=real.filter(message=>message.playbookJobs?.some(job=>job.assistantMessageId===message.id&&job.workflowRunIds?.includes(runId)));
  const candidates=jobOwners.length?jobOwners:real.filter(message=>message.playbookProgress?.workflowRunId===runId);
  if(candidates.length!==1)continue;
  const owner=candidates[0];
  const slots=[...(owner.imageSlots??[])];
  for(const slot of fallback.imageSlots??[]){
   if(!slot.resolved||slots.some(existing=>existing.resolved===slot.resolved))continue;
   const unresolved=slots.findIndex(existing=>!existing.resolved);
   if(unresolved>=0)slots[unresolved]={...slots[unresolved],resolved:slot.resolved,failed:false,errorMsg:undefined};
   else slots.push({...slot,index:Math.max(-1,...slots.map(existing=>existing.index))+1});
  }
  const merged={...owner,...(!owner.playbookProgress&&fallback.playbookProgress?{playbookProgress:{...fallback.playbookProgress,workflowRunId:runId}}:{}),...(slots.length?{imageSlots:slots}:{})};
  next=next.filter(message=>message!==fallback).map(message=>message===owner?merged:message);
 }
 return next;
}

/** Completed queue bookkeeping adds no second card when this message already
 * renders the completed workflow. Running/error states retain their controls. */
export function visiblePlaybookJobs(message:CanvasChatMessage){
 return (message.playbookJobs??[]).filter(job=>!(job.status==='completed'&&message.playbookProgress?.isDone&&message.playbookProgress.workflowRunId&&job.workflowRunIds?.includes(message.playbookProgress.workflowRunId)));
}
